import { CONNECTION_UI_STATE, connectionUiState } from '@/features/integrations'

/**
 * Is this toolkit connected and usable right now?
 *
 * A connect card is stored on the assistant message, so it outlives the
 * problem it describes. Without checking the live list, reopening an old thread
 * offers to reconnect an app that has been working for days.
 *
 * @param {{ toolkit_slug?: string, status?: string, is_disabled?: boolean }[]} connections
 * @param {string | null} toolkit Lower-cased slug.
 */
export function isToolkitLive(connections, toolkit) {
  if (!toolkit) return false
  return (connections ?? []).some(
    (connection) =>
      String(connection.toolkit_slug ?? '').toLowerCase() === toolkit &&
      connectionUiState(connection) === CONNECTION_UI_STATE.connected,
  )
}
